export default {
  collapsible: false,
  key: "panel",
  type: "panel",
  label: "Panel",
  input: false,
  tableView: false,
  components: []
};
